import Vue from 'vue'
import Router from 'vue-router'
import i18n, { setLocale, persistLang, isSupportedLang, detectLang } from '@/i18n'

Vue.use(Router)

// 解决 vue-router 3.x 重复/取消导航时控制台抛出未处理 Promise rejection 的问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => {
    if (
      Router.isNavigationFailure
        ? !Router.isNavigationFailure(err)
        : err.name !== 'NavigationDuplicated' && err.name !== 'NavigationCancelled'
    ) {
      throw err
    }
  })
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch(err => {
    if (
      Router.isNavigationFailure
        ? !Router.isNavigationFailure(err)
        : err.name !== 'NavigationDuplicated' && err.name !== 'NavigationCancelled'
    ) {
      throw err
    }
  })
}

// 透传壳组件：父路由只负责渲染子路由
const RouteView = { render: h => h('router-view') }

const router = new Router({
  mode: 'history', // 去掉 URL 中的 # 号
  // base: '/sszj/',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      redirect: () => '/' + detectLang()
    },
    {
      path: '/apply',
      redirect: () => '/' + detectLang() + '?openApply=true'
    },
    {
      path: '/:lang',
      component: RouteView,
      children: [
        {
          path: '',
          name: 'home',
          component: () => import('@/components/Home.vue'),
          meta: { titleKey: 'meta.home' }
        },
        {
          path: 'product/outbound',
          name: 'productOutbound',
          component: () => import('@/components/ProductOutbound.vue'),
          meta: { titleKey: 'meta.productOutbound' }
        },
        {
          path: 'product/inbound',
          name: 'productInbound',
          component: () => import('@/components/ProductInbound.vue'),
          meta: { titleKey: 'meta.productInbound' }
        },
        {
          path: 'solution',
          name: 'solution',
          component: () => import('@/components/Solution.vue'),
          meta: { titleKey: 'meta.solution' }
        },
        {
          path: 'faq',
          name: 'faq',
          component: () => import('@/components/Faq.vue'),
          meta: { titleKey: 'meta.faq' }
        },
        {
          path: 'about',
          name: 'about',
          component: () => import('@/components/About.vue'),
          meta: { titleKey: 'meta.about' }
        }
      ]
    }
  ]
})

// 动态写入/更新页面 meta 标签（不存在则创建）
function setMeta(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute('name', name)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

// 全局语言守卫：校验 /:lang，设置 i18n/html lang/页面标题/SEO meta
router.beforeEach((to, from, next) => {
  const lang = to.params.lang
  if (!lang) {
    return next()
  }
  if (isSupportedLang(lang)) {
    setLocale(lang)
    persistLang(lang)
    document.title = i18n.t(to.meta.titleKey || 'meta.home')
    setMeta('description', i18n.t('meta.description'))
    setMeta('keywords', i18n.t('meta.keywords'))
    next()
  } else {
    // 不支持的语言，重定向到默认语言并保留剩余路径
    const rest = to.fullPath.replace(/^\/[a-zA-Z-]{2,}/, '')
    next('/' + detectLang() + rest)
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js